import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.content = this.el.closest('.overlay-content');
        this.el.addEventListener('click', shootContentToOverlay());
        console.log(this.content.innerHTML);
    }

    shootContentToOverlay() {
        document.querySelector('.js-overlay-content-2').innerHTML = this.content.innerHTML;
    }
}
